// extracted by mini-css-extract-plugin
export default {"code":"Snippet_code__nAjNY"};